export default __webpack_public_path__ + "static/media/Infinium.a9f8f00a.png";